"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ModalAssistant = exports.Modal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Modal2 = _interopRequireDefault(require("../Modal"));
var _icons = require("../icons");
var _styles = require("../../shared/styles");
var _selectors = require("../../shared/styles/themes/selectors");
var _excluded = ["modalStyle", "background", "overlayColor"],
  _excluded2 = ["children", "text", "footer"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Modal = exports.Modal = (0, _styledComponents["default"])(_Modal2["default"]).attrs(function (_ref) {
  var modalStyle = _ref.modalStyle,
    background = _ref.background,
    overlayColor = _ref.overlayColor,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread({
    modalStyle: {
      background: background || (0, _selectors.getField)('modalAssistant.backgroundColor', props)
    },
    modalWrapperStyle: {
      backgroundColor: overlayColor || (0, _selectors.getField)('modalAssistant.overlayColor', props)
    }
  }, modalStyle);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return (0, _selectors.getField)('modalAssistant.color', props);
});
var Body = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  color: ", ";\n"])), function (props) {
  return (0, _selectors.getField)('modalAssistant.color', props);
});
var Footer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n"])), (0, _styles.margin)('m', 'top'), function (props) {
  return (0, _selectors.getField)('modalAssistant.color', props);
});
var Assistant = (0, _styledComponents["default"])(_icons.Assistant)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-right: 20px;\n  min-height: 60px;\n  min-width: 60px;\n  color: ", ";\n"])), function (props) {
  return (0, _selectors.getField)('modalAssistant.assistantColor', props);
});
var ModalAssistant = exports.ModalAssistant = function ModalAssistant(_ref2) {
  var children = _ref2.children,
    text = _ref2.text,
    footer = _ref2.footer,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(Modal, rest, /*#__PURE__*/_react["default"].createElement(Body, {
    colorType: rest.colorType
  }, /*#__PURE__*/_react["default"].createElement(Assistant, {
    colorType: rest.colorType
  }), text), footer && /*#__PURE__*/_react["default"].createElement(Footer, {
    colorType: rest.colorType
  }, footer));
};
ModalAssistant.propTypes = {
  children: _propTypes["default"].node,
  text: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  modalStyle: _propTypes["default"].object
};
var _default = exports["default"] = ModalAssistant;